import { GetterTree } from "vuex";
import { CallingState } from "./state";
import { defineVuexName, MODULES } from "../utils";

const getters: GetterTree<CallingState, any> = {
  //callingUserIds
  [defineVuexName(MODULES.CALLING.GETTERS.GET_CALLING_USER_IDS)]: (state: CallingState): string[] => {
    return state.callingUserIds;
  },
  //enabledAgoraNoiseCancelling
  [defineVuexName(MODULES.CALLING.GETTERS.GET_ENABLED_AGORA_NOISE_CANCELLING)]: (state: CallingState): boolean => {
    return state.enabledAgoraNoiseCancelling;
  },
  //checkCallingHasUserById
  [defineVuexName(MODULES.CALLING.GETTERS.GET_IS_CALLING_HAS_USER_BY_ID)]: (state: CallingState): ((userId: string) => boolean) => {
    return (userId: string) => state.callingUserIds.findIndex((id) => id === userId) > -1;
  },
  //postLocalUserReconnectedIntervalId
  [defineVuexName(MODULES.CALLING.GETTERS.GET_POSTLOCAL_USER_RECONNECTED_INTERVAL_ID)]: (state: CallingState): number | undefined => {
    return state.postLocalUserReconnectedIntervalId;
  },
  [defineVuexName(MODULES.CALLING.GETTERS.GET_VIDEO_USER_IDS)](s: CallingState) {
    return s.videoUserIds;
  },
  [defineVuexName(MODULES.CALLING.GETTERS.GET_AUDIO_USER_IDS)](s: CallingState) {
    return s.audioUserIds;
  },
  [defineVuexName(MODULES.CALLING.GETTERS.GET_IS_JOINED_SESSION)](s: CallingState) {
    return s.isJoinedSession;
  },
  //getCameraError
  [defineVuexName(MODULES.CALLING.GETTERS.GET_CAMERA_ERROR)]: (state: CallingState) => {
    return state.cameraError;
  },
  //getMicrophoneError
  [defineVuexName(MODULES.CALLING.GETTERS.GET_MICROPHONE_ERROR)]: (state: CallingState) => {
    return state.microphoneError;
  },
  [defineVuexName(MODULES.CALLING.GETTERS.GET_VIDEO_CALLING_QUALITY)](s: CallingState) {
    return s.videoCallingQuality;
  },
};

export default getters;
